// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pin-container[data-v-6e13d78b]{width:210px;margin:10px auto}.pin-input[data-v-6e13d78b]{height:48px;width:48px;padding:0;text-align:center;border:0;background-color:#f6f6f6;color:#ff6a00;margin:auto;border-radius:0}.pin-input.error[data-v-6e13d78b]{border:.5px solid red}", ""]);
// Exports
module.exports = exports;
